import * as React from 'react';
import { Link } from 'react-router-dom';
import CountryService from '../../services/CountryService';
import { observer } from 'mobx-react';

interface ICategoriesTreeProps {
  selected: Array<string>;
  categories: Array<GQL.ICategory>;
  parentId?: string;
}
@observer
class CategoriesTree extends React.Component<ICategoriesTreeProps> {
  public render(): any {
    const { selected, categories, parentId } = this.props;
    const language = CountryService.GetInstance().language;
    const countryCode = CountryService.GetInstance().countryCode;
    const currencyCode = CountryService.GetInstance().currencyCodePageParam;

    const testParentId = parentId || null;

    const categoryList = categories.filter(
      (category: GQL.ICategory) => category.parentCategoryId === testParentId,
    );

    if (categoryList && categoryList.length > 0) {
      return (
        <ul>
          {categoryList.map((category: GQL.ICategory) => {
            const subCategories = categories.filter(
              (subCategory: GQL.ICategory) => subCategory.parentCategoryId === category.id,
            );
            const classNames = [];
            if (this.isSelected(category.id)) {
              classNames.push('active');
            }
            if (subCategories.length > 0) {
              classNames.push('with-subcategories');
            }
            return (
              <li key={category.id} className={`${classNames.join(' ')}`}>
                <div>
                  {!category.parentCategoryId && (
                    <div className={`category-image ${category.slug[language]}`} />
                  )}
                  {/* Country code urls are not used anymore
                  <Link to={`/${countryCode}/products/${category.slug[language]}/`}> */}
                  <Link to={`/products/${category.slug[language]}${currencyCode ? `?currency=${currencyCode}` : ''}`}>
                    {category.name[language] || category.title}
                  </Link>
                </div>
                <CategoriesTree selected={selected} categories={categories} parentId={category.id} />
              </li>
            );
          })}
        </ul>
      );
    }

    return null;
  }

  private isSelected(categoryId: string) {
    const { selected } = this.props;

    return (selected as any).includes(categoryId);
  }
}

export default CategoriesTree;



// WEBPACK FOOTER //
// ./src/components/Categories/CategoriesTree.tsx